export default (file_id) => ({
	file_id: file_id,
	init() {
		let fileIdField = this.$root.querySelector('input[name="file_id"]');
		if (fileIdField) {
			fileIdField.value = this.file_id;
		}

		let form = this.$root.querySelector("form");
		if (form) {
			form.addEventListener("wpcf7mailsent", (e) => {
				let file = new Blob([e.detail.apiResponse.download_file]);
				var link = document.createElement("a");
				link.href = window.URL.createObjectURL(file);
				link.download = e.detail.apiResponse.download_file.replace(
					/^.*[\\\/]/,
					""
				);
				link.click();
			});
		}
	},
});
